var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "#DE3B3B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3447 5.6606C12.1377 5.45355 11.8032 5.45355 11.5961 5.6606L9 8.25142L6.40387 5.65529C6.19681 5.44824 5.86234 5.44824 5.65529 5.65529C5.44824 5.86234 5.44824 6.19681 5.65529 6.40387L8.25142 9L5.65529 11.5961C5.44824 11.8032 5.44824 12.1377 5.65529 12.3447C5.86234 12.5518 6.19681 12.5518 6.40387 12.3447L9 9.74858L11.5961 12.3447C11.8032 12.5518 12.1377 12.5518 12.3447 12.3447C12.5518 12.1377 12.5518 11.8032 12.3447 11.5961L9.74858 9L12.3447 6.40387C12.5465 6.20212 12.5465 5.86234 12.3447 5.6606Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossError);
export default __webpack_public_path__ + "static/media/crossError.27a0e2973891d912c1dbeaf5f1e7c6ed.svg";
export { ForwardRef as ReactComponent };